
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-watch/mobile-apps/google-android",
      function () {
        return require("private-next-pages/how-to-watch/mobile-apps/google-android/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to-watch/mobile-apps/google-android"])
      });
    }
  